export const GET_ALL_PROGRAMS = 'GET_ALL_PROGRAMS';
export const CREATE_PROGRAM = 'CREATE_PROGRAM';
export const UPDATE_PROGRAM = 'UPDATE_PROGRAM';
export const DELETE_PROGRAM = 'DELETE_PROGRAM';